import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'
import IntakeCard from 'candidate/components/IntakeCard'
import { QuestionWrapper } from 'candidate/components/QuestionWrapper'
import { ChoiceBucket } from 'candidate/models/intake'
import React, { useEffect, useState } from 'react'
import NextButton from 'shared/components/NextButton'

interface Props {
    internalName: string
    answer?: ChoiceBucket[]
    callback: React.Dispatch<
        React.SetStateAction<Record<string, ChoiceBucket[]>>
    >
    choices: ChoiceBucket[]
    prompt: string
    subtext?: string
    skipCallback?: React.Dispatch<React.SetStateAction<string>>
    skipText?: string
}

const MultipleResponseQuestion: React.FC<Props> = ({
    internalName,
    answer,
    callback,
    choices,
    prompt,
    subtext,
    skipCallback,
    skipText,
}: Props) => {
    const [disabled, setDisabled] = useState<boolean>(true)
    const [response, setResponse] = useState<ChoiceBucket[]>([])

    useEffect(() => {
        // TODO - This is a bit of a hack, but it works for now. Depending on team input, we need to refactor how we "skip" questions.
        // It being out of the typical options (in some cases) is making it difficult to handle.
        // reset response to be an array, otherwise it breaks if they select something new...
        setResponse(Array.isArray(answer) ? answer : [])
        // If the answer is an array, we need to check if it's empty. If it is, we should disable the next button.
        // otherwise, we should disable it if it's not an array.
        setDisabled(
            (Array.isArray(answer) && answer.length === 0) ||
                !Array.isArray(answer)
        )
    }, [answer])

    const handleSetResponse = (value: ChoiceBucket[]): void => {
        setResponse(value)
        if (value.length !== 0) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }

    // This verifies we aren't trying to use an object (for skipped options), otherwise the screen will crash.
    function doesResponseIncludeChoice(choice: ChoiceBucket): boolean {
        return Array.isArray(response) && response.includes(choice)
    }

    return (
        <IntakeCard
            question={prompt}
            subtext={subtext}
            skipCallback={skipCallback}
            skipText={skipText}
        >
            <QuestionWrapper>
                <FormGroup>
                    {choices.map((choice: ChoiceBucket, index: number) => (
                        <FormControlLabel
                            key={index}
                            label={choice.choice}
                            id={choice.choice}
                            checked={doesResponseIncludeChoice(choice)}
                            control={<Checkbox />}
                            onChange={() => {
                                handleSetResponse(
                                    doesResponseIncludeChoice(choice)
                                        ? response.filter((r) => r !== choice)
                                        : [...response, choice]
                                )
                            }}
                        />
                    ))}
                </FormGroup>
            </QuestionWrapper>

            <NextButton
                disabled={disabled}
                onClickHandler={() => {
                    setDisabled(true)
                    callback({ response: response })
                }}
            />
        </IntakeCard>
    )
}

export default MultipleResponseQuestion
